/**
 * Extract error message from various API response formats.
 * Handles blob, JSON, ArrayBuffer, and axios error responses.
 */
export async function extractApiError(error: unknown): Promise<string> {
  const defaultMessage = 'Download failed'

  // Check if it's an axios error with response data
  if (error && typeof error === 'object' && 'response' in error) {
    const axiosError = error as { response?: { data?: unknown } }
    const responseData = axiosError.response?.data

    // Handle blob response (need to parse it)
    if (responseData instanceof Blob) {
      try {
        const text = await responseData.text()
        const json = JSON.parse(text)
        return json.detail || json.error || defaultMessage
      } catch (e) {
        console.error('Failed to parse error blob response', e)
        return defaultMessage
      }
    }

    // Handle JSON response
    if (
      !(responseData instanceof ArrayBuffer) &&
      responseData &&
      typeof responseData === 'object'
    ) {
      const data = responseData as { detail?: string; error?: string }
      return data.detail || data.error || defaultMessage
    }

    // Handle ArrayBuffer response
    if (responseData instanceof ArrayBuffer) {
      const data = JSON.parse(new TextDecoder().decode(responseData)) as {
        detail?: string
        error?: string
      }
      return data.detail || data.error || defaultMessage
    }
  }

  // Handle Error instances
  if (error instanceof Error) {
    return error.message
  }

  return defaultMessage
}
